/* eslint-disable react/no-unused-state */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
import classNames from "classnames";
import PAText from "component/design-system/typography/PAText/PAText";
import PropTypes from "prop-types";
import { Component, createRef } from "react";
import Select from "react-select";
import { deepEqual } from "util/lodash/deepEqual";
import { isPopularMake, isPopularModel } from "util/vehicle/vehicle-helper";
import styles from "./VehicleSelectComponent.module.scss";

class VehicleSelect extends Component {
  inputValue: any;

  selectRef = createRef();

  constructor(props: any) {
    super(props);

    this.state = {
      selectedValue: undefined,
      disabled: props.disabled,
      isTouched: false,
    };

    this.inputValue = "";

    this.updateValue = this.updateValue.bind(this);
    this.valueRenderer = this.valueRenderer.bind(this);
    this.optionRenderer = this.optionRenderer.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.setState({ selectedValue: this.props.defaultValue });
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.defaultValue != this.props.defaultValue) {
      this.setState({ selectedValue: nextProps.defaultValue });
    } else if (this.props.resetOnSelect && !(nextProps.data.every((value, index) => deepEqual(value, this.props.data[index])))) {
      this.setState({ selectedValue: undefined });
    }
  }

  updateValue(newValue: any) {
    // the condition covers both undefined and null as undefined == null
    if (newValue != undefined) {
      this.setState({
        selectedValue: newValue.value,
      });

      if (this.props.onSelectItem != undefined) {
        this.props.onSelectItem(newValue.value);
      }
    }
  }

  valueRenderer(option: any) {
    if (this.props.valueRenderer != undefined) {
      return this.props.valueRenderer(option);
    }
    return <span>{option.label}</span>;
  }

  optionRenderer(option: any) {
    const { inputValue } = this;
    let isLabelBold = false;
    if (this.props.boldPopularMake) {
      isLabelBold = isPopularMake(option.value);
    } else if (this.props.boldPopularModel && this.props.selectedMake) {
      isLabelBold = isPopularModel(option.value);
    } else if (this.props.popularOptions) {
      isLabelBold = this.props.popularOptions.includes(option.value);
    }
    // Highlighting just options and not group's header
    if (option.value) {
      const sValue = `${option.label}`;
      if (inputValue) {
        const index = sValue.toLowerCase().indexOf(inputValue.toLowerCase());
        const [firstText, secondText, thirdText] = [
          sValue.substring(0, index),
          sValue.substring(index, index + inputValue.length),
          sValue.substring(index + inputValue.length),
        ];
        return (
          <span>

            {firstText && <span>{firstText}</span>}
            {secondText && (
              <span className={styles.highlightSpan}>{secondText}</span>
            )}

            {thirdText && <span>{thirdText}</span>}
          </span>
        );
      }
      return <PAText className={isLabelBold ? styles.bold : ""}>{option.label}</PAText>;
    }
    return option.label;
  }

  onInputChange(inputValue: any) {
    if (this.props.onInputChange) {
      inputValue = this.props.onInputChange(inputValue);
    }

    this.inputValue = inputValue;

    return inputValue;
  }

  render() {
    const { t } = this.props;
    const isSelectDropdown = this.props.placeholder.toLowerCase().includes("select");

    return (
      <>
        <Select
          // ref="select"
          ref={this.selectRef}
          singleValue
          required={this.props.required}
          className={classNames(styles.vehicleSelect, this.props.className)}
          menuContainerStyle={{ minWidth: "100%" }}
          clearable={false}
          renderInvalidValues
          placeholder={this.props.placeholder}
          value={this.state.selectedValue ? { label: this.state.selectedValue, value: this.state.selectedValue } : false}
          options={this.props.data}
          openOnFocus
          valueRenderer={this.valueRenderer}
          optionRenderer={this.optionRenderer}
          isDisabled={this.props.disabled}
          onChange={this.updateValue}
          onInputChange={this.onInputChange.bind(this)}
          onFocus={this.props.onFocus}
          onBlur={() => {
            this.setState({ isTouched: true });
            if (this.props.onBlur) {
              this.props.onBlur();
            }
          }}
          onOpen={this.props.onOpen}
          isSearchable={!isSelectDropdown}
          isLoading={this.props.isLoading}
          noResultsText={this.props.isLoading ? "" : t("No Results Found")}
          aria-label={this.props.placeholder}
          styles={{
            groupHeading: (base) => ({
              ...base, color: "#666", fontSize: "calc(1.4 * var(--safari-root-font, 10px))", fontWeight: 600,
            }),
            menu: (base) => ({
              ...base,
              border: "calc(0.1 * var(--safari-root-font, 10px)) solid #ccc",
              borderBottomRightRadius: "calc(0.4 * var(--safari-root-font, 10px))",
              borderBottomLeftRadius: "calc(0.4 * var(--safari-root-font, 10px))",
              boxShadow: "0 calc(0.1 * var(--safari-root-font, 10px)) 0 rgba(0,0,0,.06)",
              marginTop: "calc(-0.1 * var(--safari-root-font, 10px))",
              minWidth: "100%",
              zIndex: 52,
            }),
            indicatorSeparator: (base) => ({
              ...base, display: "none",
            }),
            placeholder: (base, { isDisabled, isFocused }) => {
              if (this.props.isVehicleSelectorModal) {
                return {
                  ...base,
                  position: isDisabled ? "absolute" : "unset",
                  // top: isDisabled ? "calc(-0.2 * var(--safari-root-font, 10px))" : "unset",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                };
              }
              return {
                ...base,
                position: "absolute",
                // top: this.state.isTouched || isFocused ? "unset" : "calc(-0.2 * var(--safari-root-font, 10px))",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              };
            },
            control: (base) => ({
              ...base, borderColor: "#ccc", boxShadow: "none", minHeight: "calc(3 * var(--safari-root-font, 10px))",
            }),
            valueContainer: (base) => ({
              ...base, height: "100%",
            }),
          }}
          classNamePrefix="react-select"
          components={{
            Option: ({
              innerProps, data, isFocused,
            }) => (
              <div
                {...innerProps}
                className={classNames("react-select__option", styles.option, {
                  [styles.option_focused]: isFocused,
                })}
              >
                {this.optionRenderer(data)}
              </div>
            ),
          }}
        />
        <label htmlFor={this.props.placeholder} className="hidden" />
      </>
    );
  }
}

VehicleSelect.propTypes = {
  defaultValue: PropTypes.any,
  data: PropTypes.array,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  onSelectItem: PropTypes.func,
  valueRenderer: PropTypes.func,
  onInputChange: PropTypes.func,
  onOpen: PropTypes.func,
  resetOnSelect: PropTypes.bool,
};

VehicleSelect.defaultProps = {
  data: [],
  placeholder: "TYPE VALUE...",
  disabled: false,
  resetOnSelect: true,
};

export default VehicleSelect;
